import DeliveryPlanning from './components/DeliveryProjects/DeliveryPlanning/DeliveryPlanning';
import ActivityLogModal from './components/ActivityLogs/ActivityLogModal';
import Comments from '../shared/components/Comments/Comments';
import SidebarOtherMenu from './components/Base/Frame/Sidebar/SidebarOtherMenu';
import AdminSidebar from './components/Base/Frame/Sidebar/AdminSidebar';
import AdminSidebarToggler from './components/Base/Frame/Sidebar/AdminSidebarToggler';
import SystemBar from './components/Base/Frame/SystemBar/SystemBar.vue';
import SystemBarSubmenu from './components/Base/Frame/SystemBar/SystemBarSubmenu';
import Notifications from '../shared/components/Base/Frame/UserBar/Notifications';
import CustomerCase from '../shared/components/Base/Frame/UserBar/CustomerCase';
import SuperSearch from './components/Base/Frame/UserBar/SuperSearch';
import UserBar from './components/Base/Frame/UserBar/UserBar.vue';
import UserSubmenu from '../shared/components/Base/Frame/UserBar/UserSubmenu';
import ProjectsAndCustomersGdpr from './components/Gdpr/ProjectsAndCustomersGdpr';
import CustomerAnonymizationRequests from './components/Gdpr/CustomerAnonymizationRequests';
import CustomerExcerptModal from './components/Gdpr/CustomerExcerptModal';
import ProjectAnonymizationRequests from './components/Gdpr/ProjectAnonymizationRequests';
import AnonymizeCustomerButton from './components/Gdpr/Buttons/AnonymizeCustomerButton';
import RequestCustomerExcerptButton from './components/Gdpr/Buttons/RequestCustomerExcerptButton';
import DeleteLeadButton from './components/Addresses/Leads/DeleteLeadButton';
import DeleteProductButton from './components/Products/DeleteProductButton';
import SupplierForm from './components/Products/Form/SupplierForm';
import RotRutForm from './components/Products/Form/RotRutForm';
import InvoiceTriggerForm from './components/Products/Form/InvoiceTriggerForm';
import BillectaInvoiceTriggerForm from './components/Products/Form/BillectaInvoiceTriggerForm';
import EditProjectMailshot from './components/Mailshots/EditProjectMailshot';
import CreateProspect from './components/Prospects/CreateProspect';
import EditConnectionStatistics from './components/Prospects/EditConnectionStatistics';
import AddCommunityMap from './components/Prospects/Maps/AddCommunityMap';
import EditCommunityMap from './components/Prospects/Maps/EditCommunityMap';
import EditProspectMap from './components/Prospects/Maps/EditProspectMap';
import ProspectMap from './components/Prospects/Maps/ProspectMap';
import DeactivateSalesPeriodButton from './components/Projects/SalesPeriods/DeactivateSalesPeriodButton';
import DeleteSupplierButton from './components/Suppliers/DeleteSupplierButton';
import DeleteSupplierTermButton from './components/Suppliers/DeleteSupplierTermButton';
import ActivateTeamButton from './components/Teams/ActivateTeamButton';
import DeactivateTeamButton from './components/Teams/DeactivateTeamButton';
import ActivateUserButton from '../shared/components/Users/ActivateUserButton';
import DeactivateUserButton from '../shared/components/Users/DeactivateUserButton';
import AnonymizeUserButton from './components/Users/AnonymizeUserButton';
import EmailModal from './components/Emails/EmailModal';
import DeleteUnsignedAddresses from './components/Addresses/DeleteUnsignedAddresses';
import AssignAddressesToDeliveryProject from './components/Addresses/AssignAddressesToDeliveryProject';
import ImportAddresses from './components/Addresses/ImportAddresses';
import AddressesList from './components/Addresses/AddressesList';
import DeleteProjectButton from './components/Projects/DeleteProjectButton';
import DeletePermitButton from './components/Projects/DeletePermitButton';
import LeadsMap from './components/Projects/LeadsMap';
import PreviousSalesPeriodRow from './components/Projects/SalesPeriods/PreviousSalesPeriodRow';
import UpdateProjectStatus from './components/Projects/UpdateProjectStatus';
import AddressMap from './components/Addresses/AddressMap';
import ProjectAddressesMap from './components/Projects/AddressesMap';
import DeliveryAddressesMap from './components/DeliveryProjects/Addresses/AddressesMap';
import DeleteAddressButton from './components/Addresses/DeleteAddressButton';
import ProjectMilestones from './components/Projects/ProjectMilestones/ProjectMilestones';
import CreateEmptyGroup from './components/Projects/Groups/CreateEmptyGroup';
import GroupContacts from './components/Projects/Groups/GroupContacts';
import GroupUserAgreement from './components/Projects/Groups/GroupUserAgreement';
import GroupHomepage from './components/Projects/Groups/GroupHomepage';
import DeleteGroupButton from './components/Projects/Groups/DeleteGroupButton';
import SalesPeriodAssignProjects from '../field/components/SalesPeriodAssignProjects';
import SalesPeriodAssign from '../shared/components/Projects/SalesPeriods/Assign/SalesPeriodAssign';
import SalesPeriodCreate from './components/Projects/SalesPeriods/SalesPeriodCreate';
import SalesPeriodEdit from './components/Projects/SalesPeriods/SalesPeriodEdit';
import UserSelect from './components/Users/UserSelect';
import DeliveryProjectAddressesList from './components/DeliveryProjects/Addresses/AddressesList';
import DeleteDeliveryProjectRelationButton from './components/Addresses/DeleteDeliveryProjectRelationButton';
import ImportLandPropertiesButton from './components/Projects/LandProperties/ImportLandPropertiesButton';
import DeleteLandOwnerButton from './components/Projects/LandProperties/DeleteLandOwnerButton';
import AddressesLocator from './components/Maps/AddressesLocator.vue';
import DeliveryProjectMap from './components/DeliveryProjects/DeliveryProjectMap';
import UpdateDeliveryProjectButtonModal from './components/DeliveryProjects/UpdateDeliveryProjectDetails';
import EditDeliveryProjectStatusButton from './components/DeliveryProjects/EditDeliveryProjectStatusButton';
import ConnectAddressesList from './components/DeliveryProjects/Addresses/ConnectAddresses/ConnectAddressesList';
import UploadFileArchiveFileButton from './components/UploadFileArchiveFileButton';
import Card from './components/Card/Card.vue';
import Cog from './components/Card/Actions/Cog.vue';
import tooltip from '@adaptivemedia/vue-tooltip';
import TaskList from '../vendor/laravel-tasks/components/TaskList/TaskList';
import AddToTaskList from '../vendor/laravel-tasks/components/TaskList/AddToTaskList';
import TaskListTemplateTasks from '../vendor/laravel-tasks/components/TaskListTemplateTasks';
import EditCheckboxTask from '../vendor/laravel-tasks/components/EditTaskTemplates/EditCheckboxTask';
import EditTextTask from '../vendor/laravel-tasks/components/EditTaskTemplates/EditTextTask';
import EditNumberTask from '../vendor/laravel-tasks/components/EditTaskTemplates/EditNumberTask';
import EditSelectTask from '../vendor/laravel-tasks/components/EditTaskTemplates/EditSelectTask';
import EditMultiSelectTask from '../vendor/laravel-tasks/components/EditTaskTemplates/EditMultiSelectTask';
import EditImageTask from '../vendor/laravel-tasks/components/EditTaskTemplates/EditImageTask';
import EditFileTask from '../vendor/laravel-tasks/components/EditTaskTemplates/EditFileTask';
import AddressDeliveryPhase from '../shared/components/Addresses/AddressDeliveryPhase';
import EditAddressDeliveryPhaseButton from '../shared/components/Addresses/EditAddressDeliveryPhaseButton';
import EditMissingAddressDetailsButton from '../shared/components/Addresses/EditMissingAddressDetailsButton';
import AddressFiberWorkPhase from '../shared/components/Addresses/AddressFiberWorkPhase';
import EditAddressFiberWorkPhaseButton from '../shared/components/Addresses/EditAddressFiberWorkPhaseButton';
import ActivateTechnicalServiceButton from './components/TechnicalServices/ActivateTechnicalServiceButton';
import DeactivateTechnicalServiceButton from './components/TechnicalServices/DeactivateTechnicalServiceButton';
import OrderNotificationEmailForm from './components/TechnicalServices/OrderNotificationEmailForm';
import SalesCommissionExport from './components/SalesCommissions/SalesCommissionExport';
import EditMacAddressButton from '../shared/components/Addresses/EditMacAddressButton';
import ActivateCompanyButton from './components/Companies/ActivateCompanyButton';
import DeactivateCompanyButton from './components/Companies/DeactivateCompanyButton';
import AssignCompany from './components/DeliveryProjects/Companies/AssignCompany';
import AssignFieldTechnicians from './components/DeliveryProjects/Companies/AssignFieldTechnicians';
import CompanyDeliveryProjectAddressesList from './components/Companies/DeliveryProjects/AddressesList';
import UpdateDeliveryProjectAddresses from '../admin/components/DeliveryProjects/Addresses/UpdateAddresses';
import ImportActivationPhaseAddresses from './components/Addresses/ImportActivationPhaseAddresses';
import ExportAddressListButton from './components/AddressList/ExportAddressListButton';
import FiltersInput from './components/AddressList/FiltersInput';
import DisplayFieldsInput from './components/AddressList/DisplayFieldsInput';
import MoveAddressesToDeliveryProject from './components/DeliveryProjects/Addresses/MoveAddressesToDeliveryProject';
import MoveSelectedAddressesToDeliveryProject from './components/DeliveryProjects/Addresses/MoveSelectedAddressesToDeliveryProject';
import DeleteLandPropertyButton from './components/Projects/LandProperties/DeleteLandPropertyButton';
import DeleteDeliveryProjectButton from './components/DeliveryProjects/DeleteDeliveryProjectButton';
import MoveSelectedAddresses from './components/Projects/Addresses/MoveSelectedAddresses';
import MoveAddressToProject from './components/Projects/Addresses/MoveAddressToProject';
import MoveAddressToDeliveryProject from './components/DeliveryProjects/Addresses/MoveAddressToDeliveryProject';
import MoveAddressToSalesProject from './components/Addresses/MoveAddressToSalesProject';
import HandleInvoiceManually from './components/Invoices/HandleInvoiceManually';
import SalesPeriodUnsignedAddresses from './components/Projects/SalesPeriods/UnsignedAddresses/SalesPeriodUnsignedAddresses';
import ImportDeliveryProjectAddresses from './components/DeliveryProjects/Addresses/ImportDeliveryProjectAddresses';
import DeleteExportButton from './components/Exports/DeleteExportButton';
import ShowExportErrorMessage from './components/Exports/ShowExportErrorMessage';
import DeliveryProjectTable from './components/DeliveryProjects/DeliveryProjectTable/DeliveryProjectTable';
import DeliveryProjectFilterModal from './components/DeliveryProjects/DeliveryProjectTable/DeliveryProjectTableFilterModal';
import ToggleTableColumns from './components/Filters/ToggleTableColumns';
import ToggleTableTdItem from './components/Filters/ToggleTableTdItem';
import ConvertAddressToHc from './components/Addresses/ConvertAddressToHc';
import TransferOrderButton from './components/Orders/TransferOrderButton';
import DeliveryProjectTableFilters from './components/DeliveryProjects/DeliveryProjectTable/DeliveryProjectTableFilters';
import AddressStatus from './components/Addresses/AddressStatus';
import LatestAddressInteraction from './components/Addresses/LatestAddressInteraction';
import DeliveryProjectAddressListItemDeliveryPhase from './components/DeliveryProjects/Addresses/DeliveryProjectAddressListItemDeliveryPhase';
import CreateMailshotButton from './components/Mailshots/CreateMailshotButton';
import EditMailshot from './components/Mailshots/EditMailshot';
import ExternalSystemInvoiceButton from './components/Invoices/ExternalSystemInvoiceButton';
import TimestampInColor from './components/Operations/TimestampInColor';
import ActivationExceptionCheckbox from './components/Addresses/ActivationExceptionCheckbox';
import SelectedActivationExceptionsActionCard from './components/Addresses/SelectedActivationExceptionsActionCard';
import EditMailshotModal from './components/Mailshots/EditMailshotModal';
import ImportAddressesForSalesProjectTransfer from './components/Addresses/ImportAddressesForSalesProjectTransfer';
import Percentages from './components/SubcontractorTransaction/Percentages';
import AddressDisplayWithStatus from '../shared/components/AddressDisplayWithStatus';
import DashboardQuickViewButton from './components/SubcontractorTransaction/DashboardQuickViewButton';
import SummaryQuickViewButton from './components/SubcontractorTransaction/SummaryQuickViewButton';
import PhaseInvoiceFormFields from './components/DeliveryProjects/PhaseInvoiceFormFields.vue';
import SubcontractorTransactionsSearch from './components/SubcontractorTransaction/SubcontractorTransactionsSearch.vue';
import MoveAddressesToDeliveryProjectForSalesProject
    from './components/DeliveryProjects/Addresses/MoveAddressesToDeliveryProjectForSalesProject.vue';

Vue.directive('tooltip', tooltip);

Vue.component('addresses-locator', AddressesLocator);
Vue.component('activity-log-modal', ActivityLogModal);
Vue.component('comments', Comments);
Vue.component('card', Card);
Vue.component('card-cog', Cog);

// Frame
Vue.component('sidebar-other-menu', SidebarOtherMenu);
Vue.component('admin-sidebar', AdminSidebar);
Vue.component('admin-sidebar-toggler', AdminSidebarToggler);
Vue.component('system-bar', SystemBar);
Vue.component('system-bar-submenu', SystemBarSubmenu);
Vue.component('notifications', Notifications);
Vue.component('customer-case', CustomerCase);
Vue.component('super-search', SuperSearch);
Vue.component('user-bar', UserBar);
Vue.component('user-submenu', UserSubmenu);

// GDPR
Vue.component('projects-and-customers-gdpr', ProjectsAndCustomersGdpr);
Vue.component('customer-anonymization-requests', CustomerAnonymizationRequests);
Vue.component('customer-excerpt-modal', CustomerExcerptModal);
Vue.component('project-anonymization-requests', ProjectAnonymizationRequests);
Vue.component('anonymize-customer-button', AnonymizeCustomerButton);
Vue.component('request-customer-excerpt-button', RequestCustomerExcerptButton);

// Leads
Vue.component('delete-lead-button', DeleteLeadButton);

// Products
Vue.component('delete-product-button', DeleteProductButton);
Vue.component('supplier-form', SupplierForm);
Vue.component('rot-rut-form', RotRutForm);
Vue.component('invoice-trigger-form', InvoiceTriggerForm);
Vue.component('billecta-invoice-trigger-form', BillectaInvoiceTriggerForm);

// Mailshots
Vue.component('create-mailshot-button', CreateMailshotButton);
Vue.component('edit-mailshot', EditMailshot);
Vue.component('edit-project-mailshot', EditProjectMailshot);
Vue.component('edit-mailshot-modal', EditMailshotModal);

// Prospect
Vue.component('create-prospect', CreateProspect);
Vue.component('edit-connection-statistics', EditConnectionStatistics);
Vue.component('add-community-map', AddCommunityMap);
Vue.component('edit-community-map', EditCommunityMap);
Vue.component('edit-prospect-map', EditProspectMap);
Vue.component('prospect-map', ProspectMap);
Vue.component('delivery-project-map', DeliveryProjectMap);

// Sales periods
Vue.component('deactivate-sales-period-button', DeactivateSalesPeriodButton);

// Buttons
Vue.component('delete-supplier-button', DeleteSupplierButton);
Vue.component('delete-supplier-term-button', DeleteSupplierTermButton);

Vue.component('activate-team-button', ActivateTeamButton);
Vue.component('deactivate-team-button', DeactivateTeamButton);

Vue.component('activate-user-button', ActivateUserButton);
Vue.component('deactivate-user-button', DeactivateUserButton);
Vue.component('anonymize-user-button', AnonymizeUserButton);

Vue.component('activate-technical-service-button', ActivateTechnicalServiceButton);
Vue.component('deactivate-technical-service-button', DeactivateTechnicalServiceButton);
Vue.component('order-notification-email-form', OrderNotificationEmailForm);

Vue.component('email-modal', EmailModal);

// Addresses
Vue.component('delete-unsigned-addresses', DeleteUnsignedAddresses);
Vue.component('assign-addresses-to-delivery-project', AssignAddressesToDeliveryProject);
Vue.component('import-addresses', ImportAddresses);
Vue.component('addresses-list', AddressesList);
Vue.component('edit-mac-address-button', EditMacAddressButton);
Vue.component('import-activation-phase-addresses', ImportActivationPhaseAddresses);
Vue.component('convert-address-to-hc', ConvertAddressToHc);
Vue.component('address-status', AddressStatus);
Vue.component('latest-address-interaction', LatestAddressInteraction);
Vue.component('import-addresses-for-sales-project-transfer', ImportAddressesForSalesProjectTransfer);

// Projects
Vue.component('delete-project-button', DeleteProjectButton);
Vue.component('delete-permit-button', DeletePermitButton);
Vue.component('leads-map', LeadsMap);
Vue.component('previous-sales-period-row', PreviousSalesPeriodRow);
Vue.component('update-project-status', UpdateProjectStatus);
Vue.component('address-map', AddressMap);
Vue.component('project-addresses-map', ProjectAddressesMap);
Vue.component('delivery-addresses-map', DeliveryAddressesMap);
Vue.component('delete-address-button', DeleteAddressButton);
Vue.component('delete-delivery-project-relation-button', DeleteDeliveryProjectRelationButton);
Vue.component('project-milestones', ProjectMilestones);
Vue.component('import-land-properties-button', ImportLandPropertiesButton);
Vue.component('delete-land-owner-button', DeleteLandOwnerButton);
Vue.component('delete-land-property-button', DeleteLandPropertyButton);
Vue.component('upload-file-archive-file-button', UploadFileArchiveFileButton);
Vue.component('move-addresses-to-delivery-project', MoveAddressesToDeliveryProject);
Vue.component('move-selected-addresses-to-delivery-project', MoveSelectedAddressesToDeliveryProject);
Vue.component('move-address-to-project', MoveAddressToProject);
Vue.component('move-address-to-delivery-project', MoveAddressToDeliveryProject);
Vue.component('move-address-to-sales-project', MoveAddressToSalesProject);
Vue.component('move-selected-addresses', MoveSelectedAddresses);
Vue.component('move-addresses-to-delivery-project-for-sales-project', MoveAddressesToDeliveryProjectForSalesProject);

// Groups
Vue.component('create-empty-group', CreateEmptyGroup);
Vue.component('group-contacts', GroupContacts);
Vue.component('group-user-agreement', GroupUserAgreement);
Vue.component('group-homepage', GroupHomepage);
Vue.component('delete-group-button', DeleteGroupButton);

// Sales Periods
Vue.component('sales-period-assign-projects', SalesPeriodAssignProjects);
Vue.component('sales-period-assign', SalesPeriodAssign);
Vue.component('sales-period-create', SalesPeriodCreate);
Vue.component('sales-period-edit', SalesPeriodEdit);
Vue.component('sales-period-unsigned-addresses', SalesPeriodUnsignedAddresses);

// DeliveryProjects
Vue.component('delivery-project-addresses-list', DeliveryProjectAddressesList);
Vue.component('delivery-project-update-button-modal', UpdateDeliveryProjectButtonModal);
Vue.component('edit-delivery-project-status-button', EditDeliveryProjectStatusButton);
Vue.component('delivery-planning', DeliveryPlanning);
Vue.component('address-delivery-phase', AddressDeliveryPhase);
Vue.component('delivery-project-address-list-item-delivery-phase', DeliveryProjectAddressListItemDeliveryPhase);
Vue.component('edit-address-delivery-phase-button', EditAddressDeliveryPhaseButton);
Vue.component('edit-missing-address-details-button', EditMissingAddressDetailsButton);
Vue.component('address-fiber-work-phase', AddressFiberWorkPhase);
Vue.component('edit-address-fiber-work-phase-button', EditAddressFiberWorkPhaseButton);
Vue.component('delivery-project-update-addresses', UpdateDeliveryProjectAddresses);
Vue.component('delivery-project-import-addresses', ImportDeliveryProjectAddresses);
Vue.component('delete-delivery-project-button', DeleteDeliveryProjectButton);
Vue.component('delivery-project-table', DeliveryProjectTable);
Vue.component('delivery-project-table-filter-modal', DeliveryProjectFilterModal);
Vue.component('delivery-project-table-filters', DeliveryProjectTableFilters);

Vue.component('connect-addresses-list', ConnectAddressesList);

// Users
Vue.component('user-select', UserSelect);

// Task lists
Vue.component('task-list', TaskList);
Vue.component('task-list-template-tasks', TaskListTemplateTasks);
Vue.component('edit-checkbox-task', EditCheckboxTask);
Vue.component('edit-text-task', EditTextTask);
Vue.component('edit-number-task', EditNumberTask);
Vue.component('edit-select-task', EditSelectTask);
Vue.component('edit-multi-select-task', EditMultiSelectTask);
Vue.component('edit-image-task', EditImageTask);
Vue.component('edit-file-task', EditFileTask);
Vue.component('add-to-task-list', AddToTaskList);

// Sales commission
Vue.component('sales-commission-export', SalesCommissionExport);

// Companies
Vue.component('activate-company-button', ActivateCompanyButton);
Vue.component('deactivate-company-button', DeactivateCompanyButton);
Vue.component('delivery-project-assign-company', AssignCompany);
Vue.component('delivery-project-assign-field-technicians', AssignFieldTechnicians);
Vue.component('company-delivery-project-addresses-list', CompanyDeliveryProjectAddressesList);


// Address list
Vue.component('export-address-list-button', ExportAddressListButton);
Vue.component('filters-input', FiltersInput);
Vue.component('display-fields-input', DisplayFieldsInput);

// Exports
Vue.component('delete-export-button', DeleteExportButton);
Vue.component('show-export-error-message', ShowExportErrorMessage);

// Toggle table columns
Vue.component('toggle-table-columns', ToggleTableColumns);
Vue.component('toggle-table-td-item', ToggleTableTdItem);

// Invoices
Vue.component('handle-invoice-manually', HandleInvoiceManually);
Vue.component('external-system-invoice-button', ExternalSystemInvoiceButton);

// Orders
Vue.component('transfer-order-button', TransferOrderButton);

// Operations
Vue.component('timestamp-in-color', TimestampInColor);

// Activation Exceptions
Vue.component('activation-exception-checkbox', ActivationExceptionCheckbox);
Vue.component('selected-activation-exceptions-action-card', SelectedActivationExceptionsActionCard);

// Subcontractor Transactions
Vue.component('subcontractor-transaction-percentages', Percentages);
Vue.component('phase-invoice-form-fields', PhaseInvoiceFormFields);
Vue.component('subcontractor-transactions-search', SubcontractorTransactionsSearch);

Vue.component('address-display-with-status', AddressDisplayWithStatus);

Vue.component('subcontractor-transactions-dashboard-quick-view', DashboardQuickViewButton);
Vue.component('subcontractor-transactions-summary-quick-view', SummaryQuickViewButton);
